module.exports = __webpack_public_path__ + "static/media/image11.545d6905.jpeg";